import BaseApi from '../baseApi';

export default class NotificationApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  async findAll(params) {
    params = params || {};
    const response = await this.api.get('/notifications', { params });

    return response;
  }

  async create(notification) {
    notification = notification || {};
    const response = await this.api.post('/notifications', notification);

    return response;
  }

  async markAsRead(id) {
    const response = await this.api.patch(`/notifications/${id}/read`);

    return response;
  }

  async markAsUnread(id) {
    const response = await this.api.patch(`/notifications/${id}/unread`);

    return response;
  }

  async markAllAsRead() {
    const response = await this.api.patch('/notifications/read-all');

    return response;
  }

  async clearRead() {
    const response = await this.api.delete('/notifications/read');

    return response;
  }

  async deleteByIds(ids) {
    const response = await this.api.post('/notifications/delete', { ids });

    return response;
  }

  async migrate(notifications) {
    const response = await this.api.post('/notifications/migrate', { notifications });

    return response;
  }
}
